/* eslint-disable import/no-unused-modules */
import { FormControl, FormHelperText, Input, InputLabel } from '@mui/material'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './customInputStyle.js'

export default function CustomInput(props) {
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    helperText,
    sx,
  } = props

  var helpTextClasses = classNames({
    [styles.labelRootError]: error,
    [styles.labelRootSuccess]: success && !error,
  })
  return (
    <FormControl {...formControlProps} sx={{ ...styles.formControl, ...sx }}>
      {labelText !== undefined ? (
        <InputLabel
          sx={[
            styles.labelRoot,
            error && styles.labelRootError,
            success && !error && styles.labelRootSuccess,
          ]}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        sx={[
          styles.input,
          white && styles.whiteInput,
          inputRootCustomClasses !== undefined && inputRootCustomClasses,
          styles.disabled,
          error && styles.underlineError,
          success && !error && styles.underlineSuccess,
          styles.underline,
          white && styles.whiteUnderline,
        ]}
        id={id}
        {...inputProps}
      />
      {helperText !== undefined ? (
        <FormHelperText id={id + '-text'} sx={helpTextClasses}>
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  )
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  helperText: PropTypes.node,
  sx: PropTypes.object,
}
